// @todo: merge mixin into TgForm
// @todo: rewrite validation when vuetify implemented
export default {
  data () {
    return {
      formIsValid: false,
    };
  },
  methods: {
    validateFormItem (item) {
      let rootItemValid = true;
      let childItemsValid = true;

      if (item.$children.length > 0) {
        item.$children.forEach((childItem) => {
          let isChildValid;
          if (childItem.validateAll !== undefined) {
            isChildValid = childItem.validateAll();
          } else {
            isChildValid = this.validateFormItem(childItem);
          }

          if (isChildValid === false) {
            childItemsValid = false;
          }
        });
      }

      if (item.$v !== undefined) {
        item.$v.$touch();

        if (item.$v.$invalid) {
          rootItemValid = false;
        }
      }

      return rootItemValid && childItemsValid;
    },

    validateAll (rootElm = null) {
      // store state also in local component
      return (this.formIsValid = this.validateFormItem(rootElm || this));
    },
  },
};
